export default [
  {
    key: 'increasement',
    sortable: true,
    sortField: 'createdAt',
    label: 'label.no',
    thClass: 'w-50px',
  },
  {
    key: 'title',
    sortable: false,
    label: 'field.title',
    stickyColumn: true,
    variant: 'light',
  },
  {
    key: 'isActive',
    label: 'field.status',
  },
  {
    key: 'createdAt',
    label: 'field.createDate',
  },
  {
    key: 'actions',
    label: 'general.action',
  },
]
